import React from "react";
import {Helmet} from "react-helmet";

export const About = (props) => {
  return (
    <>
    <Helmet>
      <title>Referência no RJ em Correção das Orelhas de Abano | Dra Gabriela Antonio</title>
      <meta name="description" content="A OtoSimetria é uma técnica de correção das orelhas de abano com resultado imediato e duradouro, minimamente invasivo, sem cortes, sem cirurgia, utilizando fios de sustentação inseridos sob a pele e ancorados na cartilagem. É a equivalente mais moderna e segura da Otomodelação, Otoplastia Fechada, Otoplastia Cirúrgica, EarShut, Fragilize, Harmonização de Orelhas." />
    </Helmet>
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.png" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <p><b>REFERÊNCIA EM HARMONIZAÇÃO DE ORELHAS DE ABANO</b></p>
              <h2>Sobre</h2>
              <p>Graduada em Farmácia pela Universidade Celso Lisboa</p> 
              <p>Pós-Graduada em Farmácia Estética na Faculdade Nepuga</p> 
              <p>Residência em Harmonização Facial na Velasco Academy</p> 
              <p>Curso de Correção de Orelhas de Abano - PerfectEar&copy;</p>
              <p>Especialização em Harmonização de Orelhas pelo Instituto Maycon Silveira</p>    
              <p>Fundadora da <a href="https://clinicamgm.com.br/"target="_blank" rel="noreferrer">Clínica MGM de Saúde e Estética Avançada</a></p>         
              <a href="https://api.whatsapp.com/send?phone=5521980366885&text=Ol%C3%A1,%20vi%20a%20p%C3%A1gina%20web%20e%20%20gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Dra.%20Gabriela%20Antonio." className="btn btn-custom btn-lg page-scroll" target="_blank" rel="noreferrer">
                Agendar Consulta <i className="fa fa-whatsapp"></i>
              </a>{" "}

            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
